import { ModuleWithProviders, NgModule } from '@angular/core';

import { RtUIFormsModule } from './forms/forms.module';
import { RtUIOptions } from './options';
import { PDF_VIEWER_CONFIG_TOKEN } from './pdf-viewer/pdf-viewer.di';
import { PdfViewerConfig } from './pdf-viewer/pdf-viewer.types';

@NgModule()
export class UiProvidersModule {
  public static forRoot(
    options?: RtUIOptions,
    pdfViewerConfig?: PdfViewerConfig,
  ): ModuleWithProviders<UiProvidersModule> {
    return {
      ngModule: UiProvidersModule,
      providers: [
        {
          provide: RtUIOptions,
          useValue: options,
        },
        {
          provide: PDF_VIEWER_CONFIG_TOKEN,
          useValue: pdfViewerConfig,
        },
        ...(RtUIFormsModule.forRoot().providers || []),
      ],
    };
  }
}
